import React, { useEffect, useState } from "react";
import { useUnidades } from "../../../hooks/test/useUnidades";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { Button, Card, Row, Col, Spinner, Badge } from "react-bootstrap";
import { Input } from "reactstrap";
import { Select } from "../../Select";
import moment from "moment-timezone";

const tipoTripulante = [
  {
    tipo_tripulante_id: 1,
    descripcion: "Operador",
  },
  {
    tipo_tripulante_id: 2,
    descripcion: "Maniobra",
  },
];

const tipoUnidad = [
  {
    tipo_unidad_id: 1,
    descripcion: "Camión",
  },

  {
    tipo_unidad_id: 7,
    descripcion: "Caja",
  },
];

export const EditCreateUnidad = ({
  negocio_id,
  unidad_id = null,
  marcas = [],
  colores = [],
  show,
  handleClose,
  refreshUnidades,
}) => {
  const { getUnidad, getCedisNegociosAll, putUnidad, postUnidad } =
    useUnidades();
  const [cedis, setCedis] = useState([]);
  const [form, setForm] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) return;
    setForm([]);
    setCedis([]);
    const fetchData = async () => {
      try {
        let resp = [];
        if (unidad_id) {
          resp = await getUnidad(unidad_id);
          if (resp.ok) {
            setForm(resp.unidad);
          } else {
            setForm([]);
          }
        }

        resp = await getCedisNegociosAll(negocio_id);
        if (resp.ok) {
          setCedis(resp.cedis);
        } else {
          setCedis([]);
        }
      } catch (error) {
        console.error("Error al cargar bitácora:", error);
        setForm([]);
      }
    };

    fetchData();
  }, [negocio_id, unidad_id, show]);

  const handleChange = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const saveUnidad = async (event) => {
    event.preventDefault();
    setLoading(true);
    let resp;
    if (!unidad_id) {
      resp = await postUnidad({
        unidad_numero: form.unidad_numero,
        cedis_id: form.cedis_id,
        spot: form.spot,
        unidad_vin: form.unidad_vin,
        unidad_marca: form.unidad_marca,
        unidad_modelo: form.unidad_modelo,
        unidad_placas: form.unidad_placas,
        tipo_chapa_id: form.tipo_chapa_id,
        tipo_unidad_id: form.tipo_unidad_id,
        descripcion: form.descripcion,
        unidad_color: form.unidad_color,
        nombre_transportadora: form.nombre_transportadora,
        // tipo_unidad: form.tipo_unidad,
      });
    } else {
      resp = await putUnidad(unidad_id, {
        unidad_vin: form.unidad_vin,
        unidad_marca: form.unidad_marca,
        unidad_modelo: form.unidad_modelo,
        unidad_placas: form.unidad_placas,
        unidad_numero: form.unidad_numero,
        cedis_id: form.cedis_id,
        spot: form.spot,
        tipo_chapa_id: form.tipo_chapa_id,
        descripcion: form.descripcion,
        unidad_color: form.unidad_color,
        nombre_transportadora: form.nombre_transportadora,
        // tipo_unidad: form.tipo_unidad,
      });
    }

    if (resp.ok) {
      setLoading(false);
      return Swal.fire({
        title: "Operación realizada correctamente",
        text: resp.msg,
        icon: "success",
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          if (refreshUnidades) await refreshUnidades(); // 🔹 recarga la tabla de tripulantes
          handleClose(); // 🔹 cierra el modal solo al completar con éxito
        }
      });
    } else {
      setLoading(false);
      return Swal.fire({
        title: "Lo siento, no fue posible realizar esta operación",
        text: resp.msg ? resp.msg : resp.error,
        icon: "info",
      });
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
        setForm([]);
      }}
      backdrop="static"
      keyboard={false}
      centered
      size="xl"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {unidad_id ? "Editar Unidad" : "Nueva Unidad"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={saveUnidad}>
          <div className="row justify-content-between text-left">
            <div className="form-group col-sm-6 flex-column d-flex">
              <label>Unidad Número *</label>{" "}
              <Input
                name="unidad_numero"
                id="unidad_numero"
                onChange={handleChange}
                value={form.unidad_numero}
                type="text"
                required
                labelText="Unidad número"
                placeholder={"Escribe el número de la unidad"}
                classNames="mb-4 mt-2"
                // disabled={form.unidad_id ? true : false}
              ></Input>{" "}
            </div>
            <div className="form-group col-sm-6 flex-column d-flex">
              {" "}
              <Select
                name="cedis_id"
                value={form.cedis_id}
                required
                onChange={handleChange}
                labelText="Selecciona Cedis/Hub *"
                placeholder="Selecciona una cedis/hub"
                options={cedis.map((x) => {
                  return { value: x.cedis_id, text: x.nombre_cedis };
                })}
                className="form-control mb-4 mt-2"
              ></Select>{" "}
            </div>
          </div>
          {/* <hr className="p-1" style={{ color: "#ffcd00" }}></hr>
            <div className="text-right row justify-content-end">
              <b>Campos opcionales</b>
            </div> */}

          <div className="row justify-content-between text-left">
            <div className="form-group col-sm-6 flex-column d-flex">
              {" "}
              <label>Placas</label>
              <Input
                name="unidad_placas"
                id="unidad_placas"
                onChange={handleChange}
                value={form.unidad_placas}
                type="text"
                labelText={"Placas"}
                placeholder={"Escribe el número de las placas"}
                classNames="mb-4 mt-2"
              ></Input>{" "}
            </div>
            <div className="form-group col-sm-6 flex-column d-flex">
              {" "}
              <label>Número de serie *</label>
              <Input
                name="unidad_vin"
                id="unidad_vin"
                onChange={handleChange}
                value={form.unidad_vin}
                type="text"
                required
                labelText={"VIN (Número serie)"}
                placeholder={"Escribe el VIN de la unidad"}
                classNames="mb-4 mt-2"
              ></Input>{" "}
            </div>
          </div>
          <div className="row justify-content-between text-left">
            <div className="form-group col-sm-6 flex-column d-flex">
              {" "}
              <Select
                name="unidad_marca"
                value={form.unidad_marca}
                onChange={handleChange}
                required
                labelText="Marca"
                placeholder="Selecciona una marca de unidad"
                options={marcas.map((x) => {
                  return { value: x.marca, text: x.marca };
                })}
                className="form-control mb-4 mt-2"
              ></Select>{" "}
            </div>
            <div className="form-group col-sm-6 flex-column d-flex">
              {" "}
              <label>Modelo</label>
              <Input
                name="unidad_modelo"
                id="unidad_modelo"
                onChange={handleChange}
                value={form.unidad_modelo}
                type="text"
                labelText={"Modelo"}
                placeholder={"Escribe el modelo de la unidad"}
                classNames="mb-4 mt-2"
              ></Input>
            </div>
            <div className="form-group col-sm-6 flex-column d-flex">
              {" "}
              <label>Descripción</label>
              <Input
                name="descripcion"
                onChange={handleChange}
                value={form.descripcion || ""}
                type="text"
                labelText={"Descripción"}
                placeholder={"Agrega la descripción de la unidad"}
                classNames="mb-4 mt-2"
              ></Input>
            </div>
            <div className="form-group col-sm-6 flex-column d-flex">
              {" "}
              <Select
                name="unidad_color"
                value={form.unidad_color || ""}
                onChange={handleChange}
                labelText="Color"
                placeholder="Selecciona un color de unidad"
                options={colores.map((x) => {
                  return { value: x.color, text: x.color };
                })}
                className="form-control mb-4 mt-2"
              ></Select>{" "}
            </div>
          </div>
          <div className="row justify-content-between text-left">
            <div className="form-group col-sm-6 flex-column d-flex">
              <label>¿Es unidad spot?</label>
              <select
                value={form.spot}
                name="spot"
                className="form-control mb-4 mt-2"
                placeholder="Selecciona una opción"
                onChange={handleChange}
              >
                <option value="" defaultChecked>
                  Elige una opción
                </option>
                <option value="1">SÍ</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group col-sm-6 flex-column d-flex">
              {form.spot === "1" || form.spot === 1 ? (
                <>
                  <label>Nombre de la transportadora</label>
                  <Input
                    name="nombre_transportadora"
                    id="nombre_transportadora"
                    onChange={handleChange}
                    value={form.nombre_transportadora || ""}
                    type="text"
                    labelText={"Transportadora"}
                    required={true}
                    classNames="form-group col-sm-6 flex-column d-flex"
                  ></Input>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="row text-left">
            <div className="form-group col-sm-6 flex-column d-flex">
              <label>Selecciona el tipo de chapa</label>
              <select
                value={form.tipo_chapa_id}
                name="tipo_chapa_id"
                className="form-control"
                placeholder="Selecciona una opción"
                onChange={handleChange}
              >
                <option value="" defaultChecked>
                  Elige una opción
                </option>
                <option value="1">Chapa 1</option>
                <option value="2">Chapa 2</option>
              </select>
            </div>
            <div className="form-group col-sm-6 flex-column d-flex">
              {" "}
              <Select
                name="tipo_unidad_id"
                value={form.tipo_unidad_id}
                onChange={handleChange}
                required
                labelText="Tipo de unidad *"
                disabled={unidad_id ? true : false}
                placeholder="Selecciona una tipo de unidad"
                options={tipoUnidad.map((x) => {
                  return { value: x.tipo_unidad_id, text: x.descripcion };
                })}
                className="form-control"
              ></Select>{" "}
            </div>
          </div>
          <div className="text-center pt-4">
            {loading ? (
              <Button variant="primary" disabled>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                Loading...
              </Button>
            ) : (
              <button
                type="submit"
                className="btn btn-lg liberarSalida rounded"
                style={{ background: "#0066BF", color: "white" }}
              >
                <FontAwesomeIcon icon={faSave} />
                &nbsp; {unidad_id ? "Actualizar" : "Guardar"}
              </button>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <p className="text-danger text-end">* Campos requeridos</p>
      </Modal.Footer>
    </Modal>
  );
};

export const DetailUnidad = ({ unidad_id = null, show, handleClose }) => {
  const { getUnidad } = useUnidades();

  const [loading, setLoading] = useState(false);
  const [unidad, setUnidad] = useState(null);

  useEffect(() => {
    if (!show) {
      setUnidad(null);
      return;
    }

    const fetchData = async () => {
      if (!unidad_id) return;

      setLoading(true);

      try {
        const resp = await getUnidad(unidad_id);

        if (resp.ok) {
          setUnidad(resp.unidad);
        } else {
          setUnidad(null);
        }
      } catch (error) {
        console.error("Error al cargar unidad:", error);
        setUnidad(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [show, unidad_id]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="xl"
      scrollable
    >
      {/* <Modal.Header closeButton>
        <Modal.Title>Detalle de la unidad</Modal.Title>
      </Modal.Header> */}

      <Modal.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" />
            <div className="mt-2">Cargando información...</div>
          </div>
        ) : !unidad ? (
          <div className="text-center py-5">
            No se encontró información de la unidad.
          </div>
        ) : (
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Detalle de la unidad</h5>

              <Badge bg={unidad?.cedi?.flujo_id === 2 ? "success" : "primary"}>
                {unidad?.cedi?.flujo_id === 2 ? "Automático" : "Manual"}
              </Badge>
            </Card.Header>

            <Card.Body>
              {(() => {
                const viaje = unidad?.viajes?.[0];

                const viajeAutomatico =
                  unidad?.viajes_automaticos?.[0] ?? unidad?.viajes_automaticos;

                const esAutomatico = Number(unidad?.cedi?.flujo_id) === 2;

                const cajas = esAutomatico
                  ? (viajeAutomatico?.unidades_cajas ?? [])
                  : (viaje?.unidades_cajas ?? []);

                const conductor1 = esAutomatico
                  ? viajeAutomatico?.operador
                  : viaje?.chofer;

                const conductor2 = esAutomatico ? null : viaje?.operador;

                const acompanantes = esAutomatico
                  ? [
                      viajeAutomatico?.tripulante1,
                      viajeAutomatico?.tripulante2,
                    ].filter((tripulante) => tripulante?.tripulante_id)
                  : (viaje?.tripulantes_viajes
                      ?.filter(({ isActive }) => isActive)
                      .map(({ tripulante }) => tripulante) ?? []);

                const destinos =
                  viaje?.ruta?.length > 0
                    ? viaje.ruta
                        .map(({ tienda }) => tienda?.tienda_nombre)
                        .filter(Boolean)
                    : [];

                return (
                  <Row className="g-3">
                    <Col md={6}>
                      <strong>Económico:</strong>
                      <br />
                      {unidad.unidad_numero}
                    </Col>

                    <Col md={6}>
                      <strong>Placas:</strong>
                      <br />
                      {unidad.unidad_placas || "N/A"}
                    </Col>

                    {cajas.length > 0 && (
                      <Col md={12}>
                        <hr />
                        <strong>Cajas:</strong>

                        <ul className="mt-2 mb-0 ps-3">
                          {cajas.map(({ caja }, index) => (
                            <li key={caja?.unidad_caja_id ?? index}>
                              {caja?.unidad_numero}

                              {caja?.unidad_placas && (
                                <>
                                  <br />
                                  <small className="text-muted">
                                    Placas: {caja.unidad_placas}
                                  </small>
                                </>
                              )}
                            </li>
                          ))}
                        </ul>
                      </Col>
                    )}

                    <Col md={6}>
                      <strong>VIN:</strong>
                      <br />
                      {unidad.unidad_vin}
                    </Col>

                    <Col md={6}>
                      <strong>Estatus Unidad:</strong>
                      <br />
                      {!unidad?.unidad_disponible && parseInt(unidad.status_id) === 1 ? "Deshabilitada" : unidad?.status?.nombre}
                    </Col>

                    <Col md={6}>
                      <strong>Cliente:</strong>
                      <br />
                      {unidad?.negocio?.negocio_nombre}
                    </Col>

                    <Col md={6}>
                      <strong>Centro:</strong>
                      <br />
                      {unidad?.cedi?.nombre_cedis}
                    </Col>

                    {!esAutomatico && (
                      <Col md={12}>
                        <hr />
                        <strong>Destinos:</strong>
                        <div className="mt-2">
                          {destinos.length > 0 ? (
                            <ul className="mb-0 ps-3">
                              {destinos.map((destino, index) => (
                                <li key={index}>{destino}</li>
                              ))}
                            </ul>
                          ) : (
                            <span className="text-muted">Sin destinos</span>
                          )}
                        </div>
                      </Col>
                    )}

                    {conductor1 && (
                      <Col md={6}>
                        <strong>Conductor 1:</strong>
                        <br />
                        {conductor1.nombre_completo}
                        <br />
                        <small className="text-muted">
                          {conductor1.telefono}
                        </small>
                      </Col>
                    )}

                    {conductor2 && (
                      <Col md={6}>
                        <strong>Conductor 2:</strong>
                        <br />
                        {conductor2.nombre_completo}
                        <br />
                        <small className="text-muted">
                          {conductor2.telefono}
                        </small>
                      </Col>
                    )}

                    {acompanantes.length > 0 && (
                      <Col md={12}>
                        <hr />
                        <strong>Acompañantes:</strong>

                        <ul className="mt-2 mb-0 ps-3">
                          {acompanantes.map((tripulante, index) => (
                            <li key={tripulante?.tripulante_id ?? index}>
                              {tripulante?.nombre_completo}

                              {tripulante?.telefono && (
                                <>
                                  <br />
                                  <small className="text-muted">
                                    {tripulante.telefono}
                                  </small>
                                </>
                              )}
                            </li>
                          ))}
                        </ul>
                      </Col>
                    )}
                  </Row>
                );
              })()}
            </Card.Body>

            <Card.Footer className="d-flex justify-content-between align-items-center">
              {unidad?.viajes?.[0]?.bitacora_monitorista?.[0] ? (
                <>
                  <div>
                    <strong>Último estatus</strong>
                    <br />

                    <span
                      className="badge rounded-pill me-2 d-inline-flex align-items-center gap-2 px-3 py-2"
                      title={unidad.viajes[0].bitacora_monitorista[0]?.notas}
                      style={{
                        backgroundColor:
                          unidad.viajes[0].bitacora_monitorista[0]?.status
                            ?.color || "#6c757d",
                      }}
                    >
                      <i
                        className={
                          unidad.viajes[0].bitacora_monitorista[0]?.status
                            ?.icon || "fa-solid fa-circle-info"
                        }
                      ></i>

                      {unidad.viajes[0].bitacora_monitorista[0]?.status
                        ?.nombre || "Sin estatus"}
                    </span>

                    <small className="text-muted">
                      por{" "}
                      {unidad.viajes[0].bitacora_monitorista[0]?.monitoristum
                        ?.name || "Sin asignar"}
                    </small>
                  </div>

                  <div className="text-end">
                    <strong>Última actualización</strong>
                    <br />

                    <small className="text-muted">
                      {moment
                        .utc(
                          unidad.viajes[0].bitacora_monitorista[0]
                            ?.bitacora_fecha_hora,
                        )
                        .tz("America/Mexico_City")
                        .locale("es-mx")
                        .format("DD/MM/YYYY hh:mm A")}
                    </small>
                  </div>
                </>
              ) : (
                <span className="text-muted">Sin registros de bitácora</span>
              )}
            </Card.Footer>
            <Modal.Footer className="justify-content-end border-top">
              <Button
                variant="outline-primary"
                onClick={handleClose}
                className="rounded-pill px-4"
              >
                <i className="fas fa-arrow-left me-2"></i>
                Cerrar
              </Button>
            </Modal.Footer>
          </Card>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const EditCreateTripulante = ({
  negocio_id,
  tripulante_id = null,
  show,
  handleClose,
  refreshTripulantes,
}) => {
  const {
    getTripulante,
    getCedisNegociosAll,
    putTripulantes,
    postTripulantes,
  } = useUnidades();
  const [cedis, setCedis] = useState([]);
  const [form, setForm] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) return;
    setForm([]);
    setCedis([]);
    const fetchData = async () => {
      try {
        let resp = [];
        if (tripulante_id) {
          resp = await getTripulante(tripulante_id);
          if (resp.ok) {
            setForm(resp.tripulante);
          } else {
            setForm([]);
          }
        }

        resp = await getCedisNegociosAll(negocio_id);
        if (resp.ok) {
          setCedis(resp.cedis);
        } else {
          setCedis([]);
        }
      } catch (error) {
        console.error("Error al cargar bitácora:", error);
        setForm([]);
      }
    };

    fetchData();
  }, [negocio_id, tripulante_id, show]);

  const handleChange = (event) => {
    setForm({
      ...form,
      [event.target.name]:
        typeof event.target.value === "string"
          ? event.target.value.toUpperCase()
          : event.target.value,
    });
  };

  const saveTripulante = async (event) => {
    event.preventDefault();
    const flag = validaciones();
    if (!flag) return "";
    setLoading(true);
    let resp;
    if (!tripulante_id) {
      resp = await postTripulantes({
        nombre_completo: form.nombre_completo,
        telefono: form.telefono,
        tipo_tripulante_id: form.tipo_tripulante_id,
        negocio_id: negocio_id,
        cedis_id: form.cedis_id,
      });
    } else {
      resp = await putTripulantes(tripulante_id, {
        telefono: form.telefono,
        tipo_tripulante_id: form.tipo_tripulante_id,
        negocio_id: negocio_id,
        cedis_id: form.cedis_id,
      });
    }
    if (resp.ok) {
      setLoading(false);
      return Swal.fire({
        title: "Operación realizada correctamente",
        text: resp.msg,
        icon: "success",
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          if (refreshTripulantes) await refreshTripulantes(); // 🔹 recarga la tabla de tripulantes
          handleClose(); // 🔹 cierra el modal solo al completar con éxito
        }
      });
    } else {
      setLoading(false);
      return Swal.fire({
        title: "Lo siento, no fue posible realizar esta operación",
        text: resp.msg ? resp.msg : resp.error,
        icon: "info",
      });
    }
  };

  const validaciones = () => {
    let errors = [];
    if (form.telefono.length !== 10)
      errors.push("El número de telefono debe tener 10 dígitos");

    if (errors.length > 0) {
      Swal.fire({
        title: "Lo siento!",
        text: errors,
        icon: "info",
      });
      // errors.forEach((error) => showToastError(error));
      return false;
    }

    return true;
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
        setForm([]);
      }}
      backdrop="static"
      keyboard={false}
      centered
      size="xl"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {tripulante_id ? "Editar Tripultante" : "Nuevo Tripulante"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <form onSubmit={saveTripulante}>
          <div className="container-fluid row">
            <div className="col-6">
              <label>Nombre Completo *</label>
              <input
                className="form-control"
                value={form.nombre_completo}
                name="nombre_completo"
                onChange={handleChange}
                required
                placeholder="Nombre completo *"
              ></input>
            </div>
            <div className="col-6">
              <label>Teléfono *</label>
              <input
                className="form-control"
                value={form.telefono}
                name="telefono"
                onChange={handleChange}
                required
                placeholder="Telefono *"
              ></input>
            </div>
          </div>
          <div className="container-fluid row pt-4">
            <div className="col-6">
              <label>Centro *</label>
              <select
                name="cedis_id"
                className="form-control"
                value={form.cedis_id}
                onChange={handleChange}
                required
              >
                <option value="">Selecciona</option>
                {cedis.map(({ cedis_id, nombre_cedis }) => {
                  return (
                    <option key={cedis_id} value={cedis_id}>
                      {nombre_cedis}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-6">
              <label>Tipo de tripulante *</label>
              <select
                name="tipo_tripulante_id"
                value={form.tipo_tripulante_id}
                onChange={handleChange}
                className="form-control"
                required
              >
                <option value="">Selecciona</option>
                {tipoTripulante.map(({ tipo_tripulante_id, descripcion }) => {
                  return (
                    <option key={tipo_tripulante_id} value={tipo_tripulante_id}>
                      {descripcion}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className="text-center pt-4">
            {loading ? (
              <Button variant="primary" disabled>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                Loading...
              </Button>
            ) : (
              <button
                type="submit"
                className="btn btn-lg liberarSalida rounded"
                style={{ background: "#0066BF", color: "white" }}
              >
                <FontAwesomeIcon icon={faSave} />
                &nbsp; {tripulante_id ? "Actualizar" : "Guardar"}
              </button>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <p className="text-danger text-end">* Campos requeridos</p>
      </Modal.Footer>
    </Modal>
  );
};
